/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum FreightClaimType {
  NoLossOrDomage = "no_loss_or_domage",
  Loss = "loss",
  Damage = "damage",
}

export function instanceOfFreightClaimType(value: any): boolean {
  for (const key in FreightClaimType) {
    if (Object.prototype.hasOwnProperty.call(FreightClaimType, key)) {
      if (FreightClaimType[key as keyof typeof FreightClaimType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FreightClaimTypeFromJSON(json: any): FreightClaimType {
  return FreightClaimTypeFromJSONTyped(json, false);
}

export function FreightClaimTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FreightClaimType {
  return json as FreightClaimType;
}

export function FreightClaimTypeToJSON(value?: FreightClaimType | null): any {
  return value as any;
}

export function FreightClaimTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): FreightClaimType {
  return value as FreightClaimType;
}
